import DataSource from "./DataSource";
import { GetPriceListId } from '../util/HelpfulFunctions';
import SessionManager from "./SessionManager";

var pricesCache = null;

class PriceManager {

    static async getPrices() {

        if (pricesCache) {
            return pricesCache;
        }
        else {
            pricesCache = await loadPrices()
            return pricesCache;
        }
    }

    static async getCorrectPrice(_priceUnitId, _itemUnitId){
        //TO DO return the correct price.
        return 0;
    }
}
export default PriceManager;


async function loadPrices() {

    var priceResults = await DataSource.query('ActivePrice', {
        filter: `PricelistId eq ${GetPriceListId(localStorage.getItem('userData')) ? GetPriceListId(localStorage.getItem('userData')) : '{DEFAULT}'}
                 and TraderId eq "${SessionManager.salesPointId}" or TraderId eq ""`,
        join: 'PriceItem'
    })

    if (priceResults) {
        let _filter = '';
        for (var i in priceResults) {
            if (priceResults[i]['PriceItem'] != null && priceResults[i]['PriceItem'].hasOwnProperty('ItemId')) {
                _filter = `${_filter}ItemId eq ${priceResults[i]['ItemId']} or `;
            }
        }
        _filter = _filter.substr(0, _filter.length - 4);

        var itemUnitSetupResults = await DataSource.query('ItemUnitSetup', { filter: _filter, join: "SalesUnit" });

        for (var i in priceResults) {
            let salesUnitFound = false;
            let itemNum = -1;
            for (var j in itemUnitSetupResults) {
                if (itemUnitSetupResults[j]['ItemId'] === priceResults[i]['ItemId']) {
                    salesUnitFound = true;
                    itemNum = j;
                    break;
                }
            }
            if (salesUnitFound) {
                priceResults[i]['SalesUnitDesc'] = itemUnitSetupResults[itemNum]['SalesUnit']['ShortDescription'];
                priceResults[i]['SalesUnitId'] = itemUnitSetupResults[itemNum]['SalesUnitId'];
            }
            else {
                priceResults[i]['SalesUnitDesc'] = 'TMX';
                priceResults[i]['SalesUnitId'] = 'TE';
            }

            if(priceResults[i]['UnitId'] != itemUnitSetupResults[itemNum]['SalesUnitId']){
                var correctPrice = await PriceManager.getCorrectPrice(priceResults[i]['UnitId'], itemUnitSetupResults[itemNum]['SalesUnitId']);
                priceResults[i]['UnitPrice'] = correctPrice;
                priceResults[i]['UnitId'] = itemUnitSetupResults[itemNum]['SalesUnitId'];
            }
        }

        pricesCache = priceResults;
        return priceResults;
    }
}

